export enum EnumTpAuditoria {
    AlteracaoDeStatus,
    DescontoConcedido,
    AcrescimoConcedido,
    PromocaoAplicada,
}